export const GET_ORDER = Symbol('GET_ORDER');
export const GET_ORDER_REQUEST = Symbol('GET_ORDER_REQUEST');
export const GET_ORDER_SUCCESS = Symbol('GET_ORDER_SUCCESS');
export const GET_ORDER_ERROR = Symbol('GET_ORDER_ERROR');
export const CLEAR_ORDER = Symbol('CLEAR_ORDER');


